import React from "react";
import loading from '../../static/loading.svg';
import "./Loading.css";

const Loading = props => {
  return (
    <div className={`spinner ${props.className}`}>
      <img src={loading} alt="loading"/>
    </div>
  );
};

export default Loading;


// WEBPACK FOOTER //
// ./src/common/Loading/Loading.js